import { IList, IRecord } from 'annotation-tools/utils';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import {
  CompanyAPIRawRequestBodyType,
  CompanyAPIRequestBodyType
} from './api-request-body';

export type CompanyAPIRawSuccessResponseType = {
  id: number;
  construction_company_id: number;
  name: string; // [1..50] characters
  project_count: number;
  model_count: number;
  can_be_deleted: boolean;
  created_at: string;
  updated_at: string;
};

export type CompanyAPIRawValidationErrorType = APIRawValidationErrorType<
  CompanyAPIRawRequestBodyType
>;

export type CompanyAPIValidationErrorType = APIValidationErrorType<
  CompanyAPIRequestBodyType
>;

export type ICompanyAPIValidationErrorType = IAPIValidationErrorType<
  CompanyAPIRequestBodyType
>;

export const ICompanyAPIValidationErrorFactory = IRecord<
  CompanyAPIValidationErrorType
>({
  koumutenId: IList<string>(),
  name: IList<string>()
});

/*

400 error
{
  "detail": "JSON parse error - Expecting value: line 2 column 11 (char 12)"
}

400 error
{
  "name": [
    "この項目は必須です。"
  ]
}

400 error
{
  "name": [
    "この 設計会社名 を持った 設計会社 が既に存在します。"
  ]
}


*/
